export default function App() {
  return (
    <main>
      <h1>TrueMath App</h1>
      <p>React and TypeScript are mounted. The form surface goes here.</p>
    </main>
  )
}
